import { NgModule } from '@angular/core';
import { AllOffersComponent } from './all-offers.component';

@NgModule({
  declarations: [AllOffersComponent],
  exports: [AllOffersComponent],
})
export class AllOffersModule {}
